import React from 'react';
import { NavLink } from 'react-router-dom';
import './Legal.css';

function PrivacyPolicy() {
  return (
    <main className="legal-container">
      <nav className="legal-tabs" aria-label="Legal pages">
        <NavLink to="/privacy-policy" className={({ isActive }) => isActive ? 'legal-tab active' : 'legal-tab'}>Privacy Policy</NavLink>
        <NavLink to="/terms" className={({ isActive }) => isActive ? 'legal-tab active' : 'legal-tab'}>Terms and Conditions</NavLink>
        <NavLink to="/about" className="legal-tab">About Us</NavLink>
        <NavLink to="/contact" className="legal-tab">Contact</NavLink>
      </nav>
      <header className="legal-header">
        <p className="legal-eyebrow">SponsorBoat legal</p>
        <h1>Privacy Policy</h1>
        <p>Last updated: August 22, 2026</p>
      </header>

      <article className="legal-content">
        <p>
          SponsorBoat helps brands discover content creators and helps creators present their
          YouTube channels, Instagram accounts, and blogs. This Privacy Policy explains what
          information we collect, why we use it, and the choices available to you when you use
          our website and services.
        </p>

        <section>
          <h2>1. Information We Collect</h2>
          <p>Depending on how you use SponsorBoat, we may collect:</p>
          <ul>
            <li>Account details such as your name, email address, and encrypted password.</li>
            <li>Creator listing details such as platform name, description, audience metrics, niche, location, links, contact email, and submitted photos.</li>
            <li>Contact-form details, including your name, email address, subject, and message.</li>
            <li>Subscription and payment reference details, such as plan, currency, payment ID, and order ID. Payment card information is handled by our payment provider and is not stored by SponsorBoat.</li>
            <li>Technical information such as browser, device, IP address, log data, and pages requested when needed for security and operation.</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Information</h2>
          <p>We use information to:</p>
          <ul>
            <li>Create and secure accounts and provide account support.</li>
            <li>Review, publish, organize, and display approved creator listings.</li>
            <li>Help sponsors discover creators by platform, audience size, niche, and location.</li>
            <li>Process subscriptions, confirm payments, and maintain subscription access.</li>
            <li>Respond to questions, investigate reports, prevent abuse, and keep the service reliable.</li>
            <li>Improve features, performance, and the overall SponsorBoat experience.</li>
            <li>Meet legal, accounting, fraud-prevention, and security obligations.</li>
          </ul>
        </section>

        <section>
          <h2>3. Public Creator Information</h2>
          <p>
            Creator listings are intended to be discoverable by sponsors. If your submission is
            approved, the information you provide for the listing, including your platform details,
            audience metrics, niche, location, links, photos, and contact information, may be shown
            to visitors or authenticated sponsors. Do not submit information that you do not want
            published. You can contact us to request a correction or removal of a listing.
          </p>
        </section>

        <section>
          <h2>4. When We Share Information</h2>
          <p>We may share information:</p>
          <ul>
            <li>With sponsors and site visitors when you choose to publish a creator listing.</li>
            <li>With service providers that support hosting, storage, email, authentication, payments, security, and analytics.</li>
            <li>When required by law, legal process, or a valid request from a public authority.</li>
            <li>To protect SponsorBoat, our users, or the public from fraud, abuse, security threats, or harm.</li>
            <li>As part of a business transfer, such as a merger, acquisition, financing, or sale of assets, subject to applicable law.</li>
          </ul>
          <p>We do not sell personal information for money.</p>
        </section>

        <section>
          <h2>5. Payments and Third-Party Services</h2>
          <p>
            Subscription payments are processed through Razorpay or another payment provider
            presented at checkout. Their own privacy policy and terms apply to information they
            process. SponsorBoat may also rely on cloud hosting, object storage, email, and
            infrastructure providers. These providers may process information in countries other
            than your own and may only use it to provide services to us.
          </p>
        </section>

        <section>
          <h2>6. Data Retention and Security</h2>
          <p>
            We keep information for as long as needed to provide the service, maintain business
            and legal records, resolve disputes, enforce our agreements, and prevent abuse. We use
            reasonable administrative and technical safeguards, including access controls and
            encrypted password storage. No online service or storage system can be guaranteed to
            be completely secure.
          </p>
        </section>

        <section>
          <h2>7. Your Choices and Rights</h2>
          <p>
            Depending on where you live, you may have rights to access, correct, delete, restrict,
            or receive a copy of your personal information, or object to certain processing. You
            may also request removal of a creator listing. We may need to verify your identity
            before completing a request, and some rights are limited by law. Contact us through the
            Contact page to make a request.
          </p>
        </section>

        <section>
          <h2>8. Cookies and Similar Technologies</h2>
          <p>
            SponsorBoat and its providers may use essential cookies or local storage to keep you
            signed in, protect sessions, remember preferences, and understand service performance.
            You can control cookies through your browser, but disabling essential storage may affect
            login and other features.
          </p>
        </section>

        <section>
          <h2>9. Children</h2>
          <p>
            SponsorBoat is intended for adults and business users. We do not knowingly collect
            personal information from children. If you believe a child has provided information,
            please contact us so we can review and remove it where appropriate.
          </p>
        </section>

        <section>
          <h2>10. Policy Updates and Contact</h2>
          <p>
            We may update this policy when our practices or legal obligations change. We will post
            the updated version on this page and revise the date above. For privacy questions,
            correction requests, or deletion requests, please use the <a href="/contact">Contact page</a>.
          </p>
        </section>
      </article>
    </main>
  );
}

export default PrivacyPolicy;
